<div class="h-100 flex direction-column">
  <div class="logo h64">
    <img src="./assets/logo/genex-old-dark.svg" alt="GeneX" width="140">
  </div>
  <ul nz-menu nzMode="inline" class="flex-1 sidebar-menu">
    <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>
    <ng-template #menuTpl let-menus>
      @for (menu of menus; track menu) {
      @if (menu.visible !== '1') {
      @if(menu.isFrame === '0') {
      <li nz-menu-item class="fw400 fz14" [nzPaddingLeft]="menu.level * 24" (click)="handleMenuClick(menu)" nzMatchRouter [title]="menu.menuName | translate">
        @if (menu.icon && menu.level == 1) {
        <span nz-icon [nzType]="menu.icon"></span>
        }
        <span>{{ menu.menuName | translate}}</span>
      </li>
      } @else if (menu.menuType === 'W') {
        <li nz-menu-item class="fw500 fz15" [ngClass]="{'fw600': isFontWeight}" [nzPaddingLeft]="menu.level * 24" (click)="handleMenuClick(menu)" [nzSelected]="menu.isSelected" [title]="menu.menuName | translate">
          @if (menu.icon && menu.level == 1) {
          <span nz-icon [nzType]="menu.icon"></span>
          }
          <span>{{ menu.menuName | translate}}</span>
        </li>
      } @else {
      @if (!menu.children || menu.level == 2) {
        @if (menu.menuName !== 'WhatsappRegister') {
          <li nz-menu-item class="fw400 fz14" [nzPaddingLeft]="menu.level * 24" [routerLink]="menu.fullPath" nzMatchRouter
            (click)="handleMenuClick(menu)" [title]="menu.menuName | translate">
            @if (menu.icon && menu.level == 1) {
            <span nz-icon [nzType]="menu.icon"></span>
            }
            <span>{{ menu.menuName | translate}}</span>
          </li>
        }
      } @else {
      @if (visibleMenus(menu.children).length) {
      <li nz-submenu [nzPaddingLeft]="menu.level * 24" [nzIcon]="menu.icon" [nzTitle]="menu.menuName | translate"
        class="self-submenu fw500 fz15" [ngClass]="{'fw600': menu.menuName == 'WhatsApp' || isFontWeight}"  [nzOpen]="menu.isOpen" [title]="menu.menuName | translate">
        <ul>
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: visibleMenus(menu.children) }" />
        </ul>
      </li>
      }
      }
      }
      }
      }
    </ng-template>
  </ul>
</div>